import React from 'react';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';
import CardSimple from 'screens/components/basic/CardSimple';
import NoDataMsg from 'library/noData';
import { ResponsiveContainer, ComposedChart, Line, Bar, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Cell } from "recharts";
import LOOKUP from 'constants/lookup';

const Body = ({ aggregateInventory, branchOptions, beginDate }) => {


    let chartData = aggregateInventory.map((item) => {
        for (const keyv in item) {
            if (keyv !== "date")
                item[keyv] = parseFloat(item[keyv]);
        }
        return item;
    })
    console.log(chartData);



    return (
        <div id="taxSummaryReport">
            {
                aggregateInventory.length <= 0 ?
                    //If there's NO DATA to display
                    <NoDataMsg />
                    :
                    //If there's DATA
                    <div className="clearFix">


                        <div className="col-lg-12 mt-2">
                            <div className="col-lg-12">
                                <ResponsiveContainer width="100%" height={300}>
                                    <ComposedChart width={730} height={250} data={chartData.reverse()}>
                                        <XAxis dataKey="date" />
                                        <YAxis label={{ value: 'Dollars', angle: -90, position: 'insideLeft' }} />

                                        <Tooltip />
                                        <Legend />
                                        <CartesianGrid stroke="#f5f5f5" />

                                        {branchOptions.map((item, index) => { return (<Bar dataKey={item.text} fill={LOOKUP.BranchChartColors[index].colorCode} key={index} />) })}
                                    </ComposedChart>
                                </ResponsiveContainer>
                            </div>
                            <div className="col-lg-12">
                                <ResponsiveContainer width="100%" height={300}>
                                    <ComposedChart width={730} height={250} data={chartData.reverse()}>
                                        <XAxis dataKey="date" />
                                        <YAxis label={{ value: 'Dollars', angle: -90, position: 'insideLeft' }} />

                                        <Tooltip />
                                        <Legend />
                                        <CartesianGrid stroke="#f5f5f5" />

                                        {branchOptions.map((item, index) => { return (<Area dataKey={`${item.text} - sales`} type="monotone" stroke={LOOKUP.BranchChartColors[index].colorCode} fill={LOOKUP.BranchChartColors[index].colorCode} key={index} />) })}
                                    </ComposedChart>
                                </ResponsiveContainer>
                            </div>
                        </div>

                        <div className="row m-0">


                        </div>

                    </div>
            }
        </div>
    );
};

export default Body;